import React from "react";
import {
  Dialog,
  DialogContent,
  IconButton,
  Box,
  Divider,
  DialogTitle,
} from "@mui/material";
import CustomTypography from "../../../components/common/form/CustomTypography";
import CloseIcon from "@mui/icons-material/Close";
import { PackagingSwagpack } from "../../../../models/ProjectManagement/ProjectPackagingSwagpacks";
import { observer } from "mobx-react";

interface EditPackPopupProps {
  open: boolean;
  mode?: "pack" | "bulk";
  Swagpacks: PackagingSwagpack[];
  activeSwagpackId: number | null;
  onClose: () => void;
}

const EditPackPopup: React.FC<EditPackPopupProps> = ({
  open,
  mode = "pack",
  Swagpacks,
  activeSwagpackId,
  onClose,
}) => {
  const activeSwagpack = Swagpacks?.find(
    (swagpack) => swagpack.swagpack_id === activeSwagpackId
  );

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      sx={{
        "@media (max-width:600px)": { width: "100vw", p: 0 },
      }}
      slotProps={{
        backdrop: {
          sx: {
            backdropFilter: "blur(5px)",
            backgroundColor: "rgba(0, 0, 0, 0.4)",
          },
        },
        paper: {
          sx: {
            maxHeight: "90vh",
            display: "flex",
            flexDirection: "column",
            m: 0,
            borderRadius: 2,
            p: 2,
          },
        },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          p: 3,
          pb: 1,
          pl: 5,
          pt: 2,
        }}
      >
        <CustomTypography variant="heading4"> Pack contains</CustomTypography>
        <IconButton aria-label="close" onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <Divider sx={{ mt: 1, mb: 1, width: "87%", mx: "auto" }} />

      <DialogContent>
        <Box sx={{ paddingLeft: 2, paddingRight: 2 }}>
          {activeSwagpack?.products?.map((item, idx) => (
            <Box
              key={idx}
              mb={4}
              sx={{ display: "flex", justifyContent: "space-between" }}
            >
              <Box display="flex" alignItems="center" gap={2}>
                <img
                  src={item.image_url}
                  alt={item.product_name}
                  style={{
                    width: 46,
                    height: 46,
                    objectFit: "cover",
                    borderRadius: 6,
                  }}
                />
                <Box>
                  <Box>
                    <CustomTypography variant="heading7">
                      {item.product_name}
                    </CustomTypography>
                  </Box>
                  <Box mt={1} display="flex" flexWrap="wrap" gap={2}>
                    {item.variants?.map(
                      (variant, vidx) =>
                        variant.quantity > 0 && (
                          <CustomTypography key={vidx} variant="body2">
                            {variant.size} -{" "}
                            {mode === "bulk"
                              ? variant.quantity
                              : variant.initial_quantity}
                          </CustomTypography>
                        )
                    )}
                  </Box>
                </Box>
              </Box>

              <Box>
                <CustomTypography variant="body2">
                  X
                  {mode === "bulk"
                    ? item.variants?.reduce((sum, v) => sum + v.quantity, 0)
                    : item.variants?.reduce(
                        (sum, v) => sum + v.initial_quantity,
                        0
                      )}
                </CustomTypography>
              </Box>
            </Box>
          ))}
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default observer(EditPackPopup);
